import PropTypes from 'prop-types';
import React from 'react';
import { Provider as CommunityProvider } from '../../../contexts/CommunityContext';
import { GroupConsumer } from '../../../contexts/GroupContext';
import UnderlineNavigation from '../../Elements/UnderlineNavigation/UnderlineNavigation';
import Close from '../../Icons/Close';
import SVGIconWrapper from '../../Icons/SVGIconWrapper/SVGIconWrapper';
import { privacySettingPropTypes } from '../../Includes/GroupPropsShape';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import Icons from '../../Messages/Icons/Icons';
import CardHeader from '../CardHeader/CardHeader';
import GroupHomeLink from '../Elements/GroupHomeLink/GroupHomeLink';
import ReactRouterLink from '../ReactRouterLink';

import './ManageMembers.scss';
import MemberList from './MemberList/MemberList';
import Paginations from './Paginations/Paginations';

export class ManageMembers extends React.PureComponent {
    constructor(props) {
        super();
        this.initialPage = 1;
        this.requestsResultsPerPage = 10;
        this.membersResultsPerPage = 20;
        this.state = {
            selectedMenuItem: 'Members',
            headerMenuItems: [
                {
                    text: 'Members',
                    active: true,
                    handleClickFunc: this.handleSwitchTab('Members'),
                },
                {
                    text: 'Requests',
                    active: false,
                    handleClickFunc: this.handleSwitchTab('Requests'),
                },
            ],
            memberResults: {
                members: [],
                page: 1,
                startNum: 0,
                endNum: 0,
                total: 0,
            },
            requestUserResults: {
                users: [],
                page: 1,
                startNum: 0,
                endNum: 0,
                total: 0,
            },
            goToPrevPage: null,
            goToNextPage: null,
        };
    }

    static propTypes = {
        /**
         * context state data, privacy setting of group
         */
        privacySetting: privacySettingPropTypes.isRequired,
        /**
         * context function, fetch for memberResults data
         */
        getMemberList: PropTypes.func.isRequired,
        /**
         * context function, fetch for requesting user's data
         */
        getRequestList: PropTypes.func.isRequired,
        /**
         * context function, fetch for update member's memberType
         */
        updateMember: PropTypes.func.isRequired,
        /**
         * context function, fetch for removing member
         */
        removeMember: PropTypes.func.isRequired,
        /**
         * context function, fetch for processing join request
         */
        processJoinRequest: PropTypes.func.isRequired,
        /**
         * whether the component is going to be displayed on right rail
         */
        isDisplayedOnRightRail: PropTypes.bool,
    };

    static defaultProps = {
        isDisplayedOnRightRail: false,
        getMemberList: () => {},
        getRequestList: () => {},
        updateMember: () => {},
        removeMember: () => {},
        processJoinRequest: () => {},
        privacySetting: 'open',
    };

    componentDidMount() {
        this.fetchRequestList(this.initialPage, this.requestsResultsPerPage);
        this.fetchMemberList(this.initialPage, this.membersResultsPerPage);
    }

    fetchMemberList = async (
        page = this.initialPage,
        membersResultsPerPage = this.membersResultsPerPage
    ) => {
        const { getMemberList } = this.props;
        const { headerMenuItems } = this.state;
        const newHeaderMenuItems = [...headerMenuItems];
        try {
            const res = await getMemberList(page, membersResultsPerPage, false);
            if (res) {
                const { results, startNum, endNum, total } = res;
                newHeaderMenuItems[0].text = `Members (${total})`;
                this.setState(
                    {
                        headerMenuItems: newHeaderMenuItems,
                        memberResults: {
                            members: results,
                            startNum,
                            endNum,
                            total,
                            page,
                        },
                    },
                    () => {
                        this.getGoToPrevPage();
                        this.getGoToNextPage();
                    }
                );
            }
        } catch (e) {
            console.log(e);
        }
    };

    fetchRequestList = async (
        page = this.initialPage,
        requestsResultsPerPage = this.requestsResultsPerPage
    ) => {
        const { getRequestList } = this.props;
        const { headerMenuItems } = this.state;
        const newHeaderMenuItems = [...headerMenuItems];
        try {
            const res = await getRequestList(page, requestsResultsPerPage);
            if (res) {
                const { results, startNum, endNum, total } = res;
                newHeaderMenuItems[1].text = `Requests (${total})`;
                this.setState(
                    {
                        headerMenuItems: newHeaderMenuItems,
                        requestUserResults: {
                            users: results,
                            startNum,
                            endNum,
                            total,
                            page,
                        },
                    },
                    () => {
                        this.getGoToPrevPage();
                        this.getGoToNextPage();
                    }
                );
            }
        } catch (e) {
            console.log(e);
        }
    };

    getGoToPrevPage = () => {
        const {
            selectedMenuItem,
            memberResults,
            requestUserResults,
        } = this.state;
        if (selectedMenuItem === 'Members' && memberResults.page > 1) {
            this.setState({
                goToPrevPage: () =>
                    this.fetchMemberList(
                        memberResults.page - 1,
                        this.membersResultsPerPage
                    ),
            });
        } else if (
            selectedMenuItem === 'Requests' &&
            requestUserResults.page > 1
        ) {
            this.setState({
                goToPrevPage: () =>
                    this.fetchRequestList(
                        requestUserResults.page - 1,
                        this.requestsResultsPerPage
                    ),
            });
        } else {
            this.setState({
                goToPrevPage: null,
            });
        }
    };

    getGoToNextPage = () => {
        const {
            selectedMenuItem,
            requestUserResults,
            memberResults,
        } = this.state;
        if (
            selectedMenuItem === 'Members' &&
            memberResults.page * this.membersResultsPerPage <
                memberResults.total
        ) {
            this.setState({
                goToNextPage: () =>
                    this.fetchMemberList(
                        memberResults.page + 1,
                        this.membersResultsPerPage
                    ),
            });
        } else if (
            selectedMenuItem === 'Requests' &&
            requestUserResults.page * this.requestsResultsPerPage <
                requestUserResults.total
        ) {
            this.setState({
                goToNextPage: () =>
                    this.fetchRequestList(
                        requestUserResults.page + 1,
                        this.requestsResultsPerPage
                    ),
            });
        } else {
            this.setState({
                goToNextPage: null,
            });
        }
    };

    handleSwitchTab = (menuItemText) => () => {
        const { headerMenuItems } = this.state;
        const newHeaderMenuItems = headerMenuItems.map((newItem) => {
            newItem.active = newItem.text.includes(menuItemText);
            return newItem;
        });
        this.setState(
            {
                selectedMenuItem: menuItemText,
                headerMenuItems: newHeaderMenuItems,
            },
            () => {
                this.getGoToPrevPage();
                this.getGoToNextPage();
            }
        );
    };

    handleJoinRequest = async (userId, approve) => {
        const { processJoinRequest } = this.props;
        const { requestUserResults, memberResults } = this.state;
        try {
            const res = await processJoinRequest(userId, approve);
            const isReqSuccess = res && res.meta && res.meta.success;
            if (isReqSuccess) {
                this.fetchMemberList(
                    memberResults.page,
                    this.membersResultsPerPage
                );
                this.fetchRequestList(
                    requestUserResults.page,
                    this.requestsResultsPerPage
                );
            }
        } catch (err) {
            console.log(err);
        }
    };

    handleRemoveMember = (userId) => async () => {
        const { removeMember } = this.props;
        const { memberResults } = this.state;
        try {
            const res = await removeMember(userId);
            const isReqSuccess = res && res.meta && res.meta.success;
            if (isReqSuccess) {
                if (memberResults.endNum <= memberResults.startNum) {
                    // no remaining members on this page after this one is removed - go back a page and fetch members
                    this.state.goToPrevPage();
                } else {
                    // still have remaining members on page - just fetch users for page
                    this.fetchMemberList(
                        memberResults.page,
                        this.membersResultsPerPage
                    );
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    handleUpdateMember = async (userId, memberType, callback = () => {}) => {
        const { updateMember } = this.props;
        const { memberResults } = this.state;
        try {
            const res = await updateMember(userId, memberType);
            const isReqSuccess = res && res.meta && res.meta.success;
            if (isReqSuccess) {
                const newMemberResults = { ...memberResults };
                newMemberResults.members = memberResults.members.map((member) =>
                    member.user.userId === userId
                        ? { ...member, groupMemberType: memberType }
                        : member
                );
                this.setState({ memberResults: newMemberResults });
                if (typeof callback === 'function') {
                    callback();
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    renderBackButton = () => {
        return (
            <ReactRouterLink to="/">
                <SVGIconWrapper SVGWrapperCssClass="back-caret">
                    <Icons name="back-caret" />
                </SVGIconWrapper>
            </ReactRouterLink>
        );
    };

    render() {
        const {
            selectedMenuItem,
            headerMenuItems,
            memberResults,
            requestUserResults,
            goToNextPage,
            goToPrevPage,
        } = this.state;
        const { isDisplayedOnRightRail, privacySetting } = this.props;
        const notRightRailStyle = !isDisplayedOnRightRail
            ? 'not-right-rail'
            : '';
        const isGroupOpen = privacySetting === 'open';
        const openGroupMenuItems = headerMenuItems.filter((item) =>
            item.text.includes('Members')
        );

        return (
            <div
                className={`component-Groups-ManageMembers ${notRightRailStyle}`}
            >
                <CommonCardShell className="card-shell">
                    <div className="top">
                        {this.renderBackButton()}
                        <CardHeader>Member management</CardHeader>
                        <ReactRouterLink to="/">
                            <SVGIconWrapper SVGWrapperCssClass="close-icon">
                                {Close}
                            </SVGIconWrapper>
                        </ReactRouterLink>
                    </div>
                    <UnderlineNavigation
                        menuItems={
                            isGroupOpen ? openGroupMenuItems : headerMenuItems
                        }
                        isAnchorTag={false}
                    />
                    <CommunityProvider>
                        <MemberList
                            selectedMenuItem={selectedMenuItem}
                            memberUserList={memberResults.members}
                            requestUserList={requestUserResults.users}
                            handleRemoveMember={this.handleRemoveMember}
                            handleUpdateMember={this.handleUpdateMember}
                            handleJoinRequest={this.handleJoinRequest}
                        />
                    </CommunityProvider>
                    <Paginations
                        selectedMenuItem={selectedMenuItem}
                        memberResults={memberResults}
                        requestUserResults={requestUserResults}
                        goToPrevPage={goToPrevPage}
                        goToNextPage={goToNextPage}
                    />
                    <GroupHomeLink />
                </CommonCardShell>
            </div>
        );
    }
}

export default (props) => (
    <GroupConsumer>
        {({
            getMemberList,
            getRequestList,
            group: { privacySetting },
            updateMember,
            removeMember,
            processJoinRequest,
        }) => (
            <ManageMembers
                getMemberList={getMemberList}
                getRequestList={getRequestList}
                privacySetting={privacySetting}
                updateMember={updateMember}
                removeMember={removeMember}
                processJoinRequest={processJoinRequest}
                {...props}
            />
        )}
    </GroupConsumer>
);
